import logo from './logo.svg';
import './App.css';
import './App.scss'
import CardTournament from './components/CardTournament';
import FutsalBanner from './assets/images/futsal.png'
import TepokBuluBanner from './assets/images/tepok_bulu.png'
import Layout from './components/Layout';
import HomeBanner from './assets/images/kambingcup-home.jpg'

function App() {
  return (
    <Layout file={HomeBanner}>
      <div className='min-h-screen flex flex-col justify-center items-center p-4'>
        <div className='flex w-10/12 flex-col md:flex-row'>
          <div className='md:p-5 mb-8 md:mb-0'>
            <CardTournament banner={FutsalBanner} title="Futsal 2023" url='/futsal' />
          </div>
          <div className='md:p-5'>
            <CardTournament banner={TepokBuluBanner} title="Tepok Bulu 2023" url='/tepokbulu' />
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default App;
